// src/components/Admin/VirtualScenes/SceneForm/StepZero.js
import React, { useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  validationSchemaZero,
  departamentOptions,
  accountOptions,
} from "./StepZero.form";
import "./SceneForm.scss";

const virtualSceneController = new VirtualScenes();

export function StepZero({
  formData,
  updateFormData,
  nextStep,
  isUpdateMode,
  scene,
}) {
  // Al montar, aseguramos que idScene en localStorage esté limpio
  useEffect(() => {
    localStorage.removeItem("idScene");
  }, []);

  const { accessToken, user } = useAuth();

  const formik = useFormik({
    initialValues: {
      departament: formData.departament || "",
      // Si ya había un idScene en formData o en localStorage, lo usamos
      idScene:
        formData.idScene ||
        localStorage.getItem("idScene") ||
        "",
      account: formData.account || "",
    },
    validationSchema: validationSchemaZero(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          departament: values.departament,
          idScene:     values.idScene,
          account:     values.account,
          user:        user.user._id,
        };

        if (isUpdateMode) {
          // Actualizamos subdocumento module_00
          await virtualSceneController.createModuleAdd(
            "module_00",
            accessToken,
            scene.refId,
            payload
          );
        } else {
          // Creamos y capturamos el _id de la nueva escena
          console.log("Creando nueva escena con payload:", payload);
          const response = await virtualSceneController.createModule_00(
            accessToken,
            payload
          );
          const newId = response.virtualScene._id;
          localStorage.setItem("idScene", newId);
          // Actualizamos el campo idScene en Formik
          formik.setFieldValue("idScene", newId);
        }
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      // Guardamos valores actualizados (incluido idScene si se creó) y pasamos al siguiente paso
      updateFormData({
        ...values,
        idScene: formik.values.idScene,
        user:    user.user._id,
      });
      nextStep();
    },
  });

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Campos no editables */}
      <Form.Select
        label="Departamento"
        name="departament"
        options={departamentOptions}
        value={formik.values.departament}
        disabled
      />

      {/* Ahora dejamos idScene editable */}
      <Form.Input
        label="ID de la Escena"
        name="idScene"
        onChange={formik.handleChange}
        value={formik.values.idScene}
        placeholder="Introduce el ID de la escena (o espera a que se genere)"
      />

      <Form.Select
        label="Tipo de Cuenta"
        name="account"
        options={accountOptions}
        value={formik.values.account}
        disabled
      />

      <Form.Group>
        <Button
          type="submit"
          primary
          fluid
          loading={formik.isSubmitting}
          style={{ width: "100%" }}
        >
          Siguiente
        </Button>
      </Form.Group>
    </Form>
  );
}
